import "./plugins";
import "./components";
import "./vendor";



// WEBPACK FOOTER //
// ./project/client/src/core/index.js